/**
 * 山行実績のテーブル
 */
export default function() {
  jQuery(function($){
    // アコーディオン処理
    $(`.btn-accordion`).on(`click`, function() {
      $(this).toggleClass(`is-opened`)
      $(this).next(`.contents-accordion`).toggleClass(`is-opened`)
    })
  })
}
